/**
 * Display formatting for phone numbers.
 * A placeholder such as "Not provided" is not a number and must not become a tel: link.
 */

const PLACEHOLDER_PHONE = /^(not provided( yet)?|n\/a|na|none|unknown|loading|tbd|-+|—+)$/i;

function phoneText(value) {
  if (value == null) return '';
  return String(value).trim();
}

function isPlaceholderPhone(value) {
  const text = phoneText(value);
  if (!text) return true;
  return PLACEHOLDER_PHONE.test(text);
}

function phoneDigits(value) {
  return phoneText(value).replace(/\D/g, '');
}

/** Letters left after punctuation mean this is not a phone number. */
function hasNonPhoneCharacters(value) {
  return phoneText(value).replace(/[\d\s().+\-]/g, '') !== '';
}

/**
 * A dialable number is 7 to 15 digits and not a placeholder.
 * Shorter fragments and longer strings are not linked.
 */
function dialableDigits(value) {
  if (isPlaceholderPhone(value) || hasNonPhoneCharacters(value)) return '';
  const digits = phoneDigits(value);
  if (digits.length < 7 || digits.length > 15) return '';
  return digits;
}

/**
 * US numbers, including a leading +1, display as (407) 555-0201.
 * Other dialable numbers stay as typed. Placeholders display as nothing.
 */
function formatPhoneDisplay(value) {
  const digits = dialableDigits(value);
  if (!digits) return '';
  const national = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (national.length !== 10) return phoneText(value);
  return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;
}

/** Digits only. Empty when the value should not be a tel: link. */
function phoneTelHref(value) {
  const text = phoneText(value);
  const digits = dialableDigits(value);
  if (!digits) return '';
  if (digits.length === 10) return `tel:+1${digits}`;
  if (digits.length === 11 && digits.startsWith('1')) return `tel:+${digits}`;
  if (digits.length > 11 || text.startsWith('+')) return `tel:+${digits}`;
  return `tel:${digits}`;
}

module.exports = {
  isPlaceholderPhone,
  formatPhoneDisplay,
  phoneTelHref,
};
